import i18n from "../i18n";
import React, { useState, useEffect } from "react";
import {
  Card,
  Box,
  Title,
  Text,
  Grid,
  Group,
  Badge,
  Avatar,
} from "@mantine/core";
import { UserCard } from "./consultantList";

import { IconCircleCheck } from "@tabler/icons";

import { FormSectionCard } from "../layout/page";
import { useServerApi } from "../hooks/userServerApi";
import { getProductTypeId } from "../helpers/consultantLicenceUtils";

const OrderConsultantCard = ({
  consultant,
  productTypeId,
  isSplit,
  index,
  isPrimary,
  clientTrans,
}) => {
  const [api] = useServerApi();
  const [hasLicence, setHasLicence] = useState(true);

  const checkLicences = async () => {
    try {
      if (!consultant || !consultant._id || !productTypeId) return;
      const result = await api.User.checkLicence(
        consultant._id,
        productTypeId
      );
      setHasLicence(result?.hasLicence ?? true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkLicences();
  }, [consultant?._id, productTypeId]);

  return (
    <FormSectionCard
    // title={title}
    >
      <Grid mb={"md"} justify="space-between">
        <Group spacing={3}>
          {isPrimary ? (
            <Badge size="xs" color={"green"} radius={0}>{i18n.t("Primary")}</Badge>
          ) : (
            <Badge size="xs" color={"red"} radius={0}>{i18n.t("Secondary")}</Badge>
          )}
          {clientTrans ? (
            <Badge size="xs" radius={0} color="red">
              {i18n.t("Transfer")}
            </Badge>
          ) : (
            <Badge size="xs" radius={0}>{i18n.t("Direct")}</Badge>
          )}
        </Group>

        <Group spacing={3}>
          {isSplit && (
            <Badge size="xs" radius={0}>
              Split {index + 1}
            </Badge>
          )}

          {!hasLicence && (
            <Badge
              color={"blue"}
              size="xs"
              radius={0}
              // leftSection={
              //     <IconCross size={18} style={{ paddingTop: 5 }} />
              // }
            >{i18n.t("Referer")}</Badge>
          )}

          {hasLicence && (
            <Badge
              color={"green"}
              size="xs"
              radius={0}
              leftSection={
                <IconCircleCheck size={18} style={{ paddingTop: 5 }} />
              }
            >{i18n.t("Licences")}</Badge>
          )}
        </Group>
      </Grid>

      <UserCard value={consultant} />
    </FormSectionCard>
  );
};

const OrderConsultantList = ({ form }) => {
  const { consultants, client } = form.values;
  const productTypeId = getProductTypeId(form.values);

  return (
    <>
      {consultants &&
        consultants.map((consultant, index) => (
          <OrderConsultantCard
            key={index}
            index={index}
            consultant={consultant}
            productTypeId={productTypeId}
            isSplit={consultants.length > 1}
            isPrimary={index == 0}
            clientTrans={client?.isTransfer}
          />
        ))}
    </>
  );
};

export default OrderConsultantList;
